import { use as I, insert as c, createComponent as N, effect as k, className as m, style as P, delegateEvents as W, template as $ } from "solid-js/web";
import { createSignal as a, createEffect as l, onCleanup as b, onMount as j } from "solid-js";
import { CustomPortal as B } from "../CustomPortal/index.js";
import { smartDropDownPosition as M } from "../../../node_modules/.pnpm/@rnwonder_simple-datejs@1.0.4/node_modules/@rnwonder/simple-datejs/dist/utils.js";
import { cn as g } from "../../utils/class.js";
var E = $("<div data-type=dropdown>"), x = $("<div><div>");
const H = (e) => {
  const [h, z] = a(), [f, D] = a(), [L, O] = a(), [w, R] = a(), [r, d] = a(!1), [u, v] = a(!1), p = (t) => {
    t || (t = { x: e.positionX || "center", y: e.positionY || "auto" });
    const { left: n, top: o } = M({ inputRef: w, dropDownRef: L, positionX: t.x, positionY: t.y });
    D(n), z(o);
  };
  l(() => {
    const t = () => {
      (e.isShown || r()) && p({ y: e.positionY || "auto", x: e.positionX || "center" });
    };
    document.addEventListener("scroll", t), window.addEventListener("resize", t), b(() => {
      document.removeEventListener("scroll", t), window.removeEventListener("resize", t);
    });
  }), l(() => {
    e.isShown || r() ? setTimeout(() => {
      v(!0);
    }, 100) : v(!1);
  }), l(() => {
    var t, n;
    e.isShown || r() ? ((t = e.onOpen) == null || t.call(e), p()) : (n = e.onClose) == null || n.call(e);
  }), l(() => {
    u() && p({ y: e.positionY || "auto", x: e.positionX || "center" });
  }), j(() => {
    if (document.getElementById("portal-island"))
      return;
    const t = document.createElement("div");
    t.id = "portal-island", document.body.appendChild(t);
  });
  const X = () => {
    e.handleChildrenClick ? e.handleChildrenClick(e.setIsShown || d) : e.setIsShown ? e.setIsShown(!e.isShown) : d(!r());
  }, y = () => {
    e.setIsShown ? e.setIsShown(!1) : d(!1);
  }, Y = () => {
    if (typeof e.content == "function") {
      const o = e.content({ close: y });
      return t = E(), c(t, o), t;
    }
    var t, n;
    return n = E(), c(n, () => e.content), n;
  };
  return s = x(), i = s.firstChild, s.$$keyup = (t) => {
    t.key === "Escape" && (e.isShown || r()) && y();
  }, i.$$click = X, I(R, i), c(i, () => e.children), c(s, N(B, { get setIsShown() {
    return e.setIsShown || d;
  }, get isShown() {
    return e.isShown || r();
  }, referenceId: "portal-island", hideDefaultStyle: !0, get onClickOutside() {
    return e.onClickOutside ? (t) => {
      var n;
      return (n = e.onClickOutside) == null ? void 0 : n.call(e, t, e.setIsShown || d);
    } : void 0;
  }, reference: w, get useRefWidth() {
    return e.useRefWidth;
  }, get style() {
    return { "z-index": e.zIndex || 1e3, position: "fixed", ...h() && { top: h() }, ...f() && { left: f() } };
  }, get children() {
    var t = x(), n = t.firstChild;
    return I(O, t), c(n, Y), k((o) => {
      var S = `
              ${u() ? "rn-translate-y-[0rem] rn-opacity-100" : "-rn-translate-y-[1rem] rn-opacity-0"}
              rn-duration-350 
              rn-delay-50
              rn-transition-transform
              rn-ease-in-out
              motion-reduce:rn-transition-none
          `, C = g(`
                ${u() ? "scale-100 rn-opacity-100" : "scale-90 rn-opacity-0"}
                rn-duration-350 
                rn-transition-opacity
                rn-ease-in-out
                motion-reduce:rn-transition-none
            `, e.contentClassName);
      return S !== o.e && m(t, o.e = S), C !== o.t && m(n, o.t = C), o;
    }, { e: void 0, t: void 0 }), t;
  } }), null), k((t) => {
    var n = { ...e.width && { width: e.width || "100%" } }, o = g(e.className);
    return t.e = P(i, n, t.e), o !== t.t && m(i, t.t = o), t;
  }, { e: void 0, t: void 0 }), s;
  var s, i;
};
W(["keyup", "click"]);
export {
  H as Popover
};
